/**
 * rb-qr.js — QR-code data-URL generator for the optional portfolio QR.
 *
 * Lazy-loads the vendored qrcode-generator lib and returns a data-URL the
 * renderer embeds as a plain <img> — so rb-render stays pure (no lib, no
 * canvas) and the QR travels inside the ResumeModel like the photo does.
 *
 * Depends on: RbExportText (loadVendor). globalThis.RbQr
 */
(function () {
    'use strict';

    var _cache = {};   /* url -> dataUrl */

    function loadLib() {
        if (globalThis.qrcode) return Promise.resolve();
        return globalThis.RbExportText.loadVendor('qrcode');
    }

    /* Returns a Promise<dataUrl>. Empty / failed input resolves to ''. */
    function toDataUrl(url) {
        url = String(url || '').trim();
        if (!url) return Promise.resolve('');
        if (_cache[url] !== undefined) return Promise.resolve(_cache[url]);
        return loadLib().then(function () {
            try {
                var qr = globalThis.qrcode(0, 'M');   /* type auto, ECC medium */
                qr.addData(url);
                qr.make();
                var data = qr.createDataURL(5, 1);    /* 5px cells, 1-cell margin */
                _cache[url] = data;
                return data;
            } catch (e) {
                _cache[url] = '';
                return '';
            }
        }).catch(function () { return ''; });
    }

    globalThis.RbQr = { toDataUrl: toDataUrl };
})();
